import React, { useContext } from "react";
import { observer } from "mobx-react";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import BetOfferItem from "@features/my-bets/desktop/common/BetOfferItem";

export default observer(function BetOffers() {
	const bet = useContext(MyBetsBetContext);

	if (bet.betSlipOffers == null) {
		return null;
	}

	return (
		<>
			{bet.betSlipOffers.map((offer) => (
				<BetOfferItem key={offer.id} offer={offer} />
			))}
		</>
	);
});
